export default __webpack_public_path__ + "static/loading-buffering-c7d9f0819b0870f9ad8e9c98781532a4.gif";